import { AES, enc } from "crypto-js";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { toast } from "react-toastify";

export function FDiscount(mrp: any, selling: any) {
  let _dt = ((mrp - selling) / mrp) * 100;
  let dis = Math.round(_dt).toFixed(0);
  if (dis !== "0") {
    return `${dis}%`;
  }
}
export function onlyNumber(event: any) {
  if (!/[0-9]/.test(event.key) || event.target.value?.length >= 10) {
    event.preventDefault();
  }
}
export function Timeconvert(time: any) {
  if (time && time !== null) {
    return moment(time, ["HH.mm"]).format("hh:mm A");
  }
}
const getToken = () => {
  let token: string = window.localStorage.getItem("oqu") || "";
  return token;
};
export const getUser = () => {
  let user: any;
  if (getToken()) {
    try {
      const decoded: any = jwtDecode(getToken() || "");
      user = decoded || {};
    } catch (err: any) {
      console.log(err);
    }
  } else {
    user = {};
  }
  return user;
};
export function getSelectedCity() {
  return localStorage.getItem("oq:city") || "";
}

export function getAllCityFromLocal() {
  let dt: any = JSON.parse(localStorage.getItem("oq:cityData") || "{}");
  return dt;
}
export function LoggedIn() {
  return !!localStorage.getItem("oqu");
}
export async function GetUserLatLng() {
  if (navigator?.geolocation) {
    await navigator?.geolocation.getCurrentPosition((position: any) => {
      let data: any = `${position.coords.latitude},${position.coords.longitude}`;
      return data;
    });
  }
}
export function replaceImgUriByLang(url: any) {
  let lang = localStorage.getItem("i18nextLng") || "en";
  return url.replace("public/uploads", `public/${lang}/uploads`);
}
export const groupBy = (items: any[], key: any) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  );
export const getAge = (dob: any) => {
  let age = moment().diff(new Date(dob), "years");
  return age ? `${age}` : "";
};
export const getAgeText = (dob: any) => {
  let dt = convertToDate(dob);
  let age = dt ? moment().diff(new Date(dt), "years") : "";
  return age ? `${age} Yrs` : "";
};
export const convertToDate = (date: any) => {
  if (date) {
    let _date = date?.split("-")[0];
    if (_date?.length > 2) {
      date = date;
    } else {
      date = moment(date, "'DD-MM-YYYY'").format("YYYY-MM-DD");
    }
    return date;
  } else {
    return "";
  }
};
export const alreadyInCart = (type: any, code: any) => {
  let CartItem: any[] = JSON.parse(localStorage.getItem("CartData") || "[]");
  let exist = CartItem?.find((ele: any) => ele?.Type == type && ele?.TestCode == code);
  if (exist) {
    toast.error("Already Exist in Cart");
  }
  return Boolean(exist);
};
export const cartCount = () => {
  let CartItem: any[] = JSON.parse(localStorage.getItem("CartData") || "[]");
  return CartItem?.length;
};

export const setUserDataInLocal = (data: any) => {
  let user: any = JSON.parse(localStorage.getItem("oqu-user") || "{}");
  let newData: any = {
    FirstName: data?.first_name || user?.FirstName,
    LastName: data?.last_name || user?.LastName,
    Profile_Image: "",
  };
  localStorage.setItem("oqu-user", JSON.stringify(newData));
};
export const getUserDataFromLocal = () => {
  let user: any = JSON.parse(localStorage.getItem("oqu-user") || "{}") || {};
  return user;
};
export function getFullName(first: any, last: any) {
  let full: any = `${first || ""} ${last || ""}`;
  if (full?.length > 15) {
    full = `${full?.substring(0, 14)}...`;
  }
  return full;
}
export const onlyMobile = (e: any) => {
  return (e.target.value = e.target.value?.replace(/[^0-9]/g, ""));
};
export const disableGender = (tag: string, value: any) => {
  let _male: any[] = ["mr", "master", "baby"];
  let _female: any[] = ["mrs", "ms", "baby"];
  if (value && tag) {
    if (tag == "male" && _male?.includes(value)) {
      return false;
    } else if (tag == "female" && _female?.includes(value)) {
      return false;
    } else if (tag == "others") {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};




export function encryptedData(text: any) {
  const _encryptedData = text
    ? AES.encrypt(text?.toString(), "0e9daa45f6ab49c9dfc395d0d57db2436bfb176e1be66fe4f1aaca4f318e0f9e")?.toString()
    : "";
  return _encryptedData;
}
export function decryptedData(text: any) {
  const _decryptedData = text
    ? AES.decrypt(text, "0e9daa45f6ab49c9dfc395d0d57db2436bfb176e1be66fe4f1aaca4f318e0f9e")
    : "";
  const str = _decryptedData.toString(enc.Utf8);
  return text ? str : text;
}
export const isAws = (path: any) => {
  return path.startsWith("AWS/");
};
export const isCardEmtpy = (message: boolean | undefined = true) => {
  const isCardEmpty: boolean = JSON.parse(localStorage.getItem("CartData") || "[]")?.length == 0 ? true : false;
  if (isCardEmpty && message) {
    toast.error("Card is empty, please add test/package");
  }
  return isCardEmpty;
};
export function formatTextCapitalize(text: any) {
  return text
    ? text
        ?.split("_")
        .map((word: any) => word?.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";
}

export const isBookingCancel = (status:any) => {
  if(status == "booking_cancelled" || status == "refund_approved" || status == "cancellation_pending" || status == "pending_cancellation"){
    return true
  } else {
    return false
  }
};

export const isHCNotAvail = (CityId:any) => {
  const notAvail = [119,118,117,166,109,105,101];
  return notAvail.includes(Number(CityId));
}

export function getSelectedCityData() {
  const selectedCityId: any = localStorage.getItem("oq:city");
  let cityData: any[] = JSON.parse(localStorage.getItem("oq:cityData") || "[]") || [];
  return cityData?.find((ele:any)=> ele?.Id == selectedCityId);
}

export const getComponentData = (data: any) => {
  if (typeof data === "string" && data.startsWith("[") && data.endsWith("]")) {
    try {
      const parsedData = JSON.parse(data);
      if (Array.isArray(parsedData)) {
        return parsedData.map((item) => item.title).join(", ");
      }
    } catch (e) {
      console.error("Error parsing JSON data:", e);
      return "";
    }
  } else if (Array.isArray(data)) {
    return data.map((item) => item.title).join(", ");
  } else {
    return data;
  }
};
